import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const isCaptchaDisabledScroll = isFeature('captcha-disable-scroll');

export const isCaptchaWithAutofocus = isFeature('captcha-with-autofocus');
